package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.StarW500Rounded: ImageVector
    get() {
        if (_starW500Rounded != null) {
            return _starW500Rounded!!
        }
        _starW500Rounded = Builder(name = "StarW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(358.54f, 666.54f)
                lineTo(480.0f, 593.41f)
                lineToRelative(121.46f, 74.13f)
                lineToRelative(-32.05f, -138.5f)
                lineToRelative(107.18f, -92.65f)
                lineToRelative(-140.74f, -12.52f)
                lineTo(480.0f, 292.89f)
                lineToRelative(-55.85f, 130.22f)
                lineToRelative(-140.74f, 12.28f)
                lineToRelative(107.18f, 93.41f)
                lineToRelative(-32.05f, 137.74f)
                close()
                moveTo(480.0f, 700.09f)
                lineTo(313.28f, 800.57f)
                quadToRelative(-12.67f, 7.95f, -26.35f, 6.83f)
                quadToRelative(-13.67f, -1.12f, -23.86f, -9.07f)
                quadToRelative(-10.2f, -7.96f, -15.8f, -20.01f)
                quadToRelative(-5.6f, -12.06f, -2.12f, -26.73f)
                lineToRelative(44.24f, -189.72f)
                lineToRelative(-147.72f, -127.72f)
                quadToRelative(-11.43f, -10.19f, -14.29f, -23.25f)
                quadToRelative(-2.86f, -13.05f, 1.38f, -25.49f)
                quadToRelative(4.24f, -12.43f, 13.79f, -20.63f)
                quadToRelative(9.56f, -8.19f, 25.23f, -10.19f)
                lineToRelative(194.72f, -17.0f)
                lineToRelative(75.48f, -178.96f)
                quadToRelative(5.72f, -13.91f, 17.53f, -20.63f)
                quadToRelative(11.82f, -6.72f, 24.49f, -6.72f)
                quadToRelative(12.67f, 0.0f, 24.49f, 6.72f)
                quadToRelative(11.81f, 6.72f, 17.53f, 20.63f)
                lineToRelative(75.48f, 178.96f)
                lineToRelative(194.72f, 17.0f)
                quadToRelative(15.67f, 2.0f, 25.23f, 10.19f)
                quadToRelative(9.55f, 8.2f, 13.79f, 20.63f)
                quadToRelative(4.24f, 12.44f, 1.38f, 25.49f)
                quadToRelative(-2.86f, 13.06f, -14.29f, 23.25f)
                lineTo(670.61f, 561.87f)
                lineToRelative(44.24f, 189.72f)
                quadToRelative(3.48f, 14.67f, -2.12f, 26.73f)
                quadToRelative(-5.6f, 12.05f, -15.8f, 20.01f)
                quadToRelative(-10.19f, 7.95f, -23.86f, 9.07f)
                quadToRelative(-13.68f, 1.12f, -26.35f, -6.83f)
                lineTo(480.0f, 700.09f)
                close()
                moveTo(480.0f, 490.72f)
                close()
            }
        }
        .build()
        return _starW500Rounded!!
    }

private var _starW500Rounded: ImageVector? = null
